import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 任务主页接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=148318587
export const taskHomePage = createAsyncThunk(
  'relation/task_homepage_v2',
  async (p: {target_mid: number}, store: any) => {
    const resp = await http.post(
      '/live/relation/task_homepage_v2',
      {
        ...p,
      },
      {store}
    )
    return resp.data
  }
)

interface MemberInfoType {
  id: number
  name: string
  zyid: string
  avatar: string
  avatar_urls: {
    origin: {
      urls: Array<string>
    }
    aspect_low: {
      urls: Array<string>
    }
  }
}

interface RewardInfoType {
  name: string // 名称
  icon: string // 图标
}

interface TaskInfoType {
  icon: string // 任务图标
  score: number // 完成任务加的分数
  title: string // 任务标题
  count: number // 已完成次数
  max_count: number // 最大完成次数
  finish: boolean // 是否完成
  no_limit: boolean // 是否无限制任务
}

interface LevelInfoType {
  level: number // 等级
  arrive_time: string // 到达时间
  unlock: boolean // 是否解锁
  reward_list: Array<RewardInfoType> // 奖品列表 奖品数量0-3
}
interface IRHomeState {
  my_info?: MemberInfoType
  target_info?: MemberInfoType
  exp?: number // 亲密度
  upgrade_exp?: number // 还差多少经验升级
  cur_level_exp?: number // 当前等级一共需要多少亲密度
  cur_level_got_exp?: number // 当前等级已获得经验值
  level?: number // 亲密度等级
  rate?: number // 进度条比例
  task_list?: Array<TaskInfoType> // 任务列表
  level_list?: Array<LevelInfoType> // 任务列表
}
const initialState: IRHomeState = {}
export const IRHomeSlice = createSlice({
  name: 'IRHome',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(taskHomePage.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})

export default IRHomeSlice.reducer
